import { gql } from "@apollo/client";
import { useState } from "react";
import { useQuery } from "@apollo/client";
import useAuth from "~/src/auth/hooks/use-auth";
import { checkErrors } from "~/src/utils/errors";
import { PayrollCalculation } from "../types";

type dataType = {
  account: {
    payrollCalculations: PayrollCalculation[];
  };
};

export const GET_PAYROLL_CALCULATIONS = gql`
  query payrollCalculations($search: String, $offset: Int!, $limit: Int!) {
    account {
      id
      payrollCalculations(search: $search, offset: $offset, limit: $limit) {
        id
        name
        config
        createdAt
        updatedAt
      }
    }
  }
`;

const PAGE_SIZE = 200;

export const usePayrollCalculations = (searchText: string) => {
  const auth = useAuth();
  const [isInitialFetch, setIsInitialFetch] = useState(true);
  const [limit, setLimit] = useState(PAGE_SIZE);
  const [offset, setOffset] = useState(0);

  const { loading, data, fetchMore } = checkErrors(
    useQuery(GET_PAYROLL_CALCULATIONS, {
      variables: auth.addVals(GET_PAYROLL_CALCULATIONS, {
        search: searchText,
        offset,
        limit
      }),
      fetchPolicy: isInitialFetch ? "network-only" : "cache-first",
      notifyOnNetworkStatusChange: true
    })
  );

  const payrollCalculations = data?.account?.payrollCalculations ?? [];
  const totalResults = payrollCalculations.length;

  return {
    loading: isInitialFetch && loading,
    loadingMore: !isInitialFetch && loading,
    payrollCalculations,
    hasMore: payrollCalculations.length < totalResults,
    fetchMore: () => {
      if (payrollCalculations.length < totalResults) {
        setIsInitialFetch(false);
        const newOffset = offset + limit;
        setOffset(newOffset);

        fetchMore({
          variables: {
            offset: newOffset,
            limit: PAGE_SIZE
          },
          fetchPolicy: "network-only"
        }).then(({ data }: { data: dataType }) => {
          setLimit(limit + data.account.payrollCalculations.length);
        });
      }
    }
  };
};
